import {Pipe, PipeTransform} from '@angular/core';
import {IdentificationDocument} from '../../global/util/IdentificationDocument';

@Pipe({
  name: 'descriptionDocumentType'
})
export class DescriptionDocumentTypePipe implements PipeTransform {

  transform(documentType: string): string {
    switch (Number(documentType)) {
      case IdentificationDocument.DNI:
        return 'DNI';
      case IdentificationDocument.CE:
        return 'CARNÉ EXTRANJERÍA';
      case IdentificationDocument.PAS:
        return 'PASAPORTE';
    }
    return 'OTROS';
  }
}
